// gets all elements in DOM order for the selectors specified in the parameter
function collectAllElementsDeep(selector = null, root) {
  const allElements = [];

  const findAllElements = nodes => {
    // eslint-disable-next-line no-cond-assign
    for (let i = 0, el; (el = nodes[i]); i += 1) {
      allElements.push(el);
      // If the element has a shadow root, dig deeper.
      if (el.shadowRoot) {
        findAllElements(el.shadowRoot.querySelectorAll('*'));
      }
    }
  };
  if (root.shadowRoot) {
    findAllElements(root.shadowRoot.querySelectorAll('*'));
  }
  findAllElements(root.querySelectorAll('*'));

  return selector ? allElements.filter(el => el.matches(selector)) : allElements;
}

function getFocusableElements(elem = document) {
  return collectAllElementsDeep('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', elem);
}

export { getFocusableElements };
